module.exports = __webpack_public_path__ + "78f642839bec747fa9f006536b4563b2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/adventure-tube-yellow.png
// module id = 1840
// module chunks = 0